export { SpaEntityConfigWizard } from './SpaEntityConfigWizard';
